"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const material_kit_pro_react_1 = require("../../assets/jss/material-kit-pro-react");
const styles = (theme) => (0, styles_1.createStyles)({
    container: material_kit_pro_react_1.container,
    coloredShadow: material_kit_pro_react_1.coloredShadow,
    centered: {
        display: 'flex',
        justifyContent: 'center'
    },
    earnHeader: {
        marginTop: theme.spacing(4)
    },
    optionImage: {
        height: 150,
        width: 200,
        backgroundSize: 'contain',
        cursor: 'pointer'
    },
    optionImageLarge: {
        height: 350,
        width: 350,
        [theme.breakpoints.down('sm')]: {
            width: 'auto'
        }
    },
    optionImageModal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    optionImageModalImage: {
        minWidth: '700px',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%'
        }
    },
    surveyCard: {
        paddingBottom: theme.spacing(4),
        paddingTop: theme.spacing(4)
    },
    surveyInput: {
        outline: 'auto',
        backgroundColor: theme.palette.common.white
    },
    surveyBtn: {
        width: '40%',
        alignSelf: 'center',
        [theme.breakpoints.down('xs')]: {
            marginBottom: theme.spacing(4)
        }
    },
    dropDownRoot: {
        width: '100%'
    },
    selectLabel: {
        paddingTop: theme.spacing(3),
        paddingLeft: theme.spacing(2)
    },
    radioContent: {
        alignItems: 'normal',
        marginBottom: theme.spacing()
    },
    radioButton: {
        alignItems: 'normal',
        padding: 2,
        marginRight: theme.spacing()
    },
    quizRadioButton: {
        alignItems: 'normal',
        padding: 5,
        marginRight: theme.spacing()
    },
    surveyAnswer: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4)
        }
    }
});
exports.default = styles;
//# sourceMappingURL=SurveyScreenStyle.js.map